export default __webpack_public_path__ + "static/media/news3.424b2e34.jpg";